import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SendEventActionsService } from '@app/core/services/events/sendEventActions.service';

import { ModalController } from '@ionic/angular';

@Component({
    selector: 'service-worker',
    templateUrl: './service-worker.component.html',
    styleUrls: ['./service-worker.component.css'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ServiceWorkerComponent implements OnInit {
    clickedOkButton = false;

    constructor(
        private sendEventActionService: SendEventActionsService,
        private modalCtrl: ModalController
    ) {}

    ngOnInit() {
        this.sendEventActionService.sendEventActions({
            pageview: '/sw-version-modal-open',
            eventAction: 'swVersionModalOpen',
            eventCategory: 'ServiceWorker',
            ddAction: 'swVersionModalOpen',
        });
    }

    dismiss() {
        this.clickedOkButton = true;

        this.sendEventActionService.sendEventActions({
            pageview: '/sw-hard-refresh-triggered',
            eventAction: 'swHardRefreshTriggered',
            eventCategory: 'ServiceWorker',
            ddAction: 'swHardRefreshTriggered',
        });

        this.modalCtrl.dismiss(true);
        //this.workerService.reload();
    }
}
